export const MODAL_Z_INDEX = 100

export const EXPECTS_SIGN_IN_KEY = 'expectsSignIn'
